import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { buildComposerState, paths } from '@shared/config';

/**
 * «+ Карточка» на страницах, кроме «Слов и модулей» (ТЗ главной § 5): карточки создаются строкой внизу «Слов и
 * модулей» (с 2026-10-23, раньше — главной), кнопка ведёт туда с флагом `focusComposer` — страница берёт его один раз
 * и стирает (на компьютере каретка в поле, на телефоне поле вспыхивает). Страницы «Из словаря» больше нет (решение
 * владельца 2026-10-21); неподтверждённую почту и закончившийся доступ объясняет сама строка. На телефоне кнопка — над
 * панелью вкладок (`--tabbar-h` задаёт оболочка).
 */
export function CardFab() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const open = () => navigate(paths.words, { state: buildComposerState() });
  return (
    <button
      type="button"
      title={t('createCard.fabTitle')}
      onClick={open}
      className="card-fab group fixed bottom-[calc(var(--tabbar-h,0px)+env(safe-area-inset-bottom,0px)+1.5rem)] right-5 z-[150] inline-flex h-14 items-center gap-2.5 rounded-pill bg-accent pl-[18px] pr-[22px] text-sm font-semibold tracking-[0.01em] text-fg-inv shadow-[0_18px_36px_-10px_rgba(243,106,28,0.55),0_4px_12px_-2px_rgba(0,0,0,0.25)] transition-transform duration-150 hover:-translate-y-0.5 hover:scale-[1.02] nav:right-6"
    >
      <span className="inline-flex h-6 w-6 items-center justify-center rounded-pill bg-[rgba(20,20,22,0.18)] text-lg font-normal leading-none">
        +
      </span>
      {t('createCard.fab')}
    </button>
  );
}
